import { render, staticRenderFns } from "./IconInstagram.vue?vue&type=template&id=7f15c61c&scoped=true&"
import script from "./IconInstagram.vue?vue&type=script&lang=js&"
export * from "./IconInstagram.vue?vue&type=script&lang=js&"
import style0 from "./IconInstagram.vue?vue&type=style&index=0&id=7f15c61c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f15c61c",
  null
  
)

export default component.exports